import * as actionTypes from "./galleryActionType";
import axios from 'axios';
import { checkError, apiTimeout } from './../error';
const { REACT_APP_API_URL } = process.env;

export const fetchGallery = () => {
    return (dispatch) => {
        dispatch(fetchGalleryInit());
        apiTimeout(axios.get(`${REACT_APP_API_URL}/gallery`))
        .then((response) => {
            dispatch(fetchGallerySuccess(response.data.data));
        })
        .catch(function (error) {
            dispatch(fetchGalleryFailure());
            checkError(error);
        })
    };
};

export const fetchGalleryInit = () => ({
    type: actionTypes.FETCH_GALLERY
});

export const fetchGalleryFailure = () => ({
    type: actionTypes.FETCH_GALLERY_FAILURE
});

export const fetchGallerySuccess = data => ({
    type: actionTypes.FETCH_GALLERY_SUCCESS,
    payload: { data }
});
